module.exports = __webpack_public_path__ + "img/c7.5883e1fd.svg";